import styled from "styled-components";

export const StrokeLine = styled.line`
  stroke-width: 1;
  stroke-dasharray: 4 4;
  stroke: var(--icon-ebony-stroke, var(--ebony));
  pointer-events: none;
`;

export const SeekTimeText = styled.text`
  fill: var(--menu-ebony-light-color, var(--ebony-light));
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 10px;
  font-weight: 600;
  line-height: 22px;
`;

export const SeekTimeContainer = styled.rect`
  fill: var(--menu-snow-background-color, var(--snow));
`;
